import { Select } from "components/ui/Select/Select";
import type { FC } from "react";

const MARGIN_OPTIONS: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 15, 20];
const MARGIN_SELECT_OPTIONS = MARGIN_OPTIONS.map(m => ({
  value: String(m),
  label: `${m}万円`,
}));

export type MarginSelectProps = {
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
};

/**
 * 自社マージン（万円）を選択するプルダウン
 *
 * AI メール本文生成時、提案する人材 / 案件の単価にこの margin を加算・減算して
 * 自社を挟む前提の提示単価を作成するために使用する。
 *
 * @param {MarginSelectProps} props props
 * @param {number} props.value 選択中のマージン値（万円）
 * @param {Function} props.onChange 変更ハンドラ
 * @param {boolean} [props.disabled] 無効化フラグ
 * @return {JSX.Element} JSX
 */
export const MarginSelect: FC<MarginSelectProps> = ({
  value,
  onChange,
  disabled,
}) => {
  return (
    <div>
      <label className="label py-0">
        <span className="label-text text-xs">
          自社マージン
          <span className="text-gray-400 ml-1">（AI生成の単価補正に使用）</span>
        </span>
      </label>
      <Select
        options={MARGIN_SELECT_OPTIONS}
        value={String(value)}
        isDisabled={disabled}
        onChange={next => {
          if (next !== undefined) onChange(Number(next));
        }}
        size="sm"
      />
    </div>
  );
};
